<template>
  <div class="d-flex"
       :style="{ overflowX: allowOverflow ? 'auto' : 'visible' }">
    <v-col class="align-self-stretch"
           style="padding: 0 1px"
           cols="12"
           md="6"
           lg="4"
           xl="3"
           v-for="(step, index) in sequenceSteps"
           :key="step.id">
      <StepCard :step="step"
                :sequence-full-start-date="selectedSequence.initSequenceAt"
                :previous-step-beginning-time-in-minutes="getPreviousStepTimeInMinutes(index)"
                style="margin: 2px 0"
                @showUpdateStepDialog="showUpdateStepDialog($event)" />
    </v-col>

    <v-col class="align-self-stretch"
           style="padding: 0 1px"
           cols="12"
           md="6"
           lg="4"
           xl="3">
      <AddStepCard card-color="#FB6340"
                   style="margin: 2px 0"
                   @showAddStepDialog="showAddStepDialog()">
      </AddStepCard>
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddStepCard from '@/pages/App/Sequences/Steps/AddStepCard'
import StepCard from '@/pages/App/Sequences/Steps/StepCard'
export default {
  components: { AddStepCard, StepCard },
  computed: {
    ...mapState({
      selectedSequence: state => state.sequences.selectedSequence,
      sequenceSteps: state => state.sequences.sequenceSteps
    }),
    stepsDelayTimeInMinutes () {
      return this.sequenceSteps.map(step => {
        const { afterStepInitIn, timeUnits } = step.goToNextStepAfter
        return this.setTimeInMinutes(afterStepInitIn, timeUnits)
      })
    }
  },
  methods: {
    getPreviousStepTimeInMinutes (stepIndex) {
      if (stepIndex === 0) return 0
      const previousStepTimesSumInMinutes = this.stepsDelayTimeInMinutes.slice(0, stepIndex)
      return previousStepTimesSumInMinutes.reduce(function (a, b) {
        return a + b
      }, 0)
    },
    setTimeInMinutes (timeToTransform, timeUnits) {
      let timeToMinutesConverter = 1
      const time = parseInt(timeToTransform)
      if (timeUnits === 'days') {
        timeToMinutesConverter = 1440
      } else if (timeUnits === 'hours') {
        timeToMinutesConverter = 60
      }
      return time * timeToMinutesConverter
    },
    showAddStepDialog () {
      this.$emit('showAddStepDialog')
    },
    showUpdateStepDialog (stepId) {
      this.$emit('showUpdateStepDialog', stepId)
    }
  },
  props: {
    allowOverflow: {
      type: Boolean,
      default: false
    }
  }
}
</script>
